export const MODAL_SHEET_SIZES = {
    Small: 'small',
    Medium: 'medium',
    Large: 'large',
} as const;

export const ANIMATION_DELAY = 300;
